import { AuthRole } from '@newfront-insurance/auth-api';
import type { AuthProviderContext, AuthProviderProps } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';

import { usePermission } from './use-permission';

export function useIsEngineer(authProvider: Provider<AuthProviderContext, AuthProviderProps>): boolean {
  return usePermission({ scopes: [AuthRole.ENGINEER] }, authProvider);
}
